var Validator = {
    isValidUrl: function (str) {
        var pattern = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        if (!pattern.test(str)) {
            return false;
        } else {
            return true;
        }
    },

    isDateTime: function (str) {
        var pattern = /Date\(([^)]+)\)/;
        return pattern.test(str);
    },

    isEmailAddressValid: function (address) {
        //var pattern = /^(0[1-9]|1[0-2])\/\d{4}$/g;
        //var pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
        var pattern = /^[^@]+@[^@]+\.[^@\.]{2,}$/;

        return pattern.test(address);
    },

    isValidDoubleWithCulture: function (input, cultureInfo) {
        var numberReSnippet = "(?:NaN|-?(?:(?:\\d+|\\d*\\" + cultureInfo.DecimalSeparator + "\\d+)(?:[E|e][+|-]?\\d+)?|Infinity))";
        var matchOnlyNumberRe = new RegExp("^(" + numberReSnippet + ")$");
        return matchOnlyNumberRe.test(input);
    },

    isValidInvariantDouble: function (input) {
        var numberReSnippet = "(?:NaN|-?(?:(?:\\d+|\\d*\\.\\d+)(?:[E|e][+|-]?\\d+)?|Infinity))";
        var matchOnlyNumberRe = new RegExp("^(" + numberReSnippet + ")$");
        return matchOnlyNumberRe.test(input);
    }
}

globalThis.Validator = Validator;